export default from './delete-category-modal';



// WEBPACK FOOTER //
// ./app/containers/delete-category-modal/index.js